import { Component, ViewEncapsulation } from '@angular/core';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { ICellRendererParams } from 'ag-grid-community';

@Component({
  selector: 'user-name-renderer',
  templateUrl: './user-name-renderer.component.html',
  styleUrls: ['./user-name-renderer.component.scss'],
  encapsulation: ViewEncapsulation.None
})

export class UserNameRendererComponent implements ICellRendererAngularComp {
  params: ICellRendererParams;
  public userName : string;
  public imgSrc : string = '';
  constructor() {

  }

  initilize(params: ICellRendererParams) {
    if (params && params.data) {
      this.userName = params.data.Display_Name;
      this.imgSrc = params.data.User_Image?.trim() 
                    ? params.data.User_Image 
                    : '../../../assets/sample-user.svg';
    }   
  }

  // called on init
  agInit(params: any): void {
    this.initilize(params);
  }

  // called when the cell is refreshed
  refresh(params: any): boolean {
    this.initilize(params);
    return true;
  }

}
